/**
 * BI instrumentation for the character builder.
 *
 * - pipeline/: builds and sends CHARACTER_ACTION and CLICK_ELEMENT events
 *   through event-pipeline-lib (consent, user, cookies, IP, platform). It knows
 *   nothing about Redux or the builder.
 * - middleware.ts and registry.ts: a Redux middleware that turns builder
 *   actions into events, using one mapper per interaction in mappers/.
 * - helpers/: small utilities shared by the above.
 */
import { createInstrumentationMiddleware } from "./middleware";
import { characterActionMappers, clickElementMappers } from "./registry";

export const instrumentationMiddleware = createInstrumentationMiddleware(
  characterActionMappers,
  clickElementMappers
);

export {
  getEnableAllPartneredContentClick,
  getSourceCategoryClick,
  getToggleClick,
} from "./mappers/settings";
export {
  getBackToCampaignClick,
  getChoosePremadeClick,
  getClaimPremadeClick,
  getPremadeFilterClick,
  getPremadeRulesetClick,
  getPremadeSubscribeClick,
  getPreviewPremadeClick,
  getWatchTourClick,
} from "./mappers/premade";
export { getChangeLocation } from "./helpers/changeLocation";
export * from "./pipeline";
